import React from 'react';
import { X } from '@finect/tabular-icons/x';
import { ErrorBox, Inner, Discard, DiscardButton } from './partials';
export var ErrorMessage = function ErrorMessage(_ref) {
  var discardError = _ref.discardError;
  var refresh = function refresh() {
    window.location.reload(true);
  };
  return React.createElement(ErrorBox, null, React.createElement(Inner, null, "Parece que algo ha ido mal.", ' ', React.createElement(Discard, {
    onClick: refresh
  }, "Recarga", React.createElement("span", null, " para continuar")), "."), React.createElement(DiscardButton, {
    onClick: discardError
  }, React.createElement(X, null)));
};